import find from 'lodash/fp/find';
import get from 'lodash/fp/get';
import isArray from 'lodash/isArray';

const mergeInclude = (relationships, included, path) => {
  const { data } = get(path, relationships);
  if (!data) return null;
  if (isArray(data)) {
    return data.map((entity) => {
      const merge = find({ type: entity.type, id: entity.id }, included);
      if (!merge) return entity;
      return ({
        ...entity,
        ...merge,
      });
    })
  } else {
    const merge = find({ type: data.type, id: data.id }, included);
    if (!merge) return data;
    return ({
      ...data,
      ...merge,
    });
  }
};

export default mergeInclude;
